export const getLocalValue = (key) => {
    if (typeof window === 'undefined')
        return null;
    try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    }
    catch (_a) {
        return null;
    }
};
export const setLocalValue = (key, value) => {
    if (typeof window === 'undefined')
        return;
    try {
        localStorage.setItem(key, JSON.stringify(value));
    }
    catch (_a) {
        console.warn('[localStorage] Failed to save value for key:', key);
    }
};
export const removeLocalValue = (key) => {
    if (typeof window === 'undefined')
        return;
    try {
        localStorage.removeItem(key);
    }
    catch (_a) {
        console.warn('[localStorage] Failed to remove value for key:', key);
    }
};
